export const VOTING_TYPE_LABELS = {
  HONORARY_POSITION: "Cargos Honorarios",
  RANKING: "Ranking ASOFOM",
  YES_NO: "Sí / No",
};

export function getVotingTypeLabel(typeKey, fallback = "Proceso de votación") {
  return VOTING_TYPE_LABELS[String(typeKey || "").toUpperCase()] || fallback;
}

export function normalizeBallotManifest(manifest) {
  if (!manifest || typeof manifest !== "object") {
    throw new Error("El manifiesto de boleta no es válido");
  }

  return {
    ...manifest,
    typeKey: String(manifest.typeKey || "").toUpperCase(),
    contests: Array.isArray(manifest.contests) ? manifest.contests : [],
  };
}

export function formatVotingDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("es-MX");
}

export function parseVotingQueryValue(value) {
  if (Array.isArray(value)) return value[0] || "";
  return value || "";
}

export function getVotingShareToken(shareUrl) {
  const match = String(shareUrl || "").match(/\/resultados\/([^/?#]+)/i);
  return match ? decodeURIComponent(match[1]) : "";
}

export function getLocalVotingResultsUrl(shareUrl) {
  const token = getVotingShareToken(shareUrl);
  return token ? `/resultados/${encodeURIComponent(token)}` : shareUrl || "";
}
